/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ClusterIconStyle, MarkerClustererOptions } from '@googlemaps/markerclustererplus';

const workOrderClusterSvg = './assets/images/plots/ic-work-order-clustering-icon.svg';

const baseClusterStyle: ClusterIconStyle = {
  height: 28,
  width: 40,
  anchorText: [0, 6],
  textColor: '#ffffff',
  textSize: 10
};

export const trackableClusterOptions: MarkerClustererOptions = {
  maxZoom: 16,
  gridSize: 30,
  clusterClass: 'vehicle-cluster-badge',
  zIndex: 3,
  zoomOnClick: false,
  styles: [
    {
      ...baseClusterStyle,
      backgroundPosition: '10px 8px'
    },
    {
      ...baseClusterStyle,
      backgroundPosition: '8px 8px'
    },
    {
      ...baseClusterStyle,
      backgroundPosition: '6px 8px'
    }
  ]
};

export const workOrderClusterOptions: MarkerClustererOptions = {
  maxZoom: 16,
  gridSize: 30,
  clusterClass: 'work-order-cluster-badge',
  zIndex: 2,
  zoomOnClick: true,
  styles: [
    {
      ...baseClusterStyle,
      url: workOrderClusterSvg,
      backgroundPosition: '10px 8px'
    },
    {
      ...baseClusterStyle,
      url: workOrderClusterSvg,
      backgroundPosition: '8px 8px'
    },
    {
      ...baseClusterStyle,
      url: workOrderClusterSvg,
      backgroundPosition: '6px 8px'
    }
  ]
};
